// extracted by mini-css-extract-plugin
module.exports = {"safearea":"InteractiveDetails_safearea__s72zm"};